import React from 'react'
import { Box } from 'designSystem'
import CrossIcon from 'components/Images/CrossIcon'
import { QcNotesIssueType } from 'pages/Shows/Audiobooks/constants'
import {
  StyledQCTable,
  StyledTextAreaField,
  StyledInputField,
  StyledSelectField,
  StyledRowColumn,
  StyledRowHeading,
} from './styled'
import { QCNotesCreatorsCategories } from './constants'

const NewQCNoteTable = ({ newQcNotes = [], setNewQcNotes }) => {
  const handleChange = ({ index, event }) => {
    const { name, value } = event.target
    if (name === 'time' && !value.match(/^[\d:-]*$/)) {
      return true
    }

    setNewQcNotes((prevQcNotes) => {
      const RowsInput = structuredClone(prevQcNotes)
      RowsInput[index][name] = value
      return RowsInput
    })
  }

  const onRemoveRow = (index) => {
    setNewQcNotes((prevQcNotes) => {
      const RowsInput = structuredClone(prevQcNotes)
      RowsInput.splice(index, 1)
      return RowsInput
    })
  }

  return (
    <Box py={8}>
      <StyledQCTable>
        <thead>
          <tr>
            <StyledRowHeading>Time</StyledRowHeading>
            <StyledRowHeading>Issue Type</StyledRowHeading>
            <StyledRowHeading>Category</StyledRowHeading>
            <StyledRowHeading>Remarks</StyledRowHeading>
          </tr>
        </thead>
        <tbody>
          {newQcNotes.map((data, index) => (
            <tr key={data.id}>
              <StyledRowColumn>
                <StyledInputField
                  type="text"
                  name="time"
                  value={data.time || ''}
                  onChange={(event) => handleChange({ index, event })}
                />
              </StyledRowColumn>
              <StyledRowColumn>
                <StyledSelectField
                  name="issue_type"
                  value={data.issue_type || ''}
                  width={6.87}
                  onChange={(event) => handleChange({ index, event })}
                >
                  {QcNotesIssueType.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </StyledSelectField>
              </StyledRowColumn>
              <StyledRowColumn>
                <StyledSelectField
                  name="category"
                  value={data.category || ''}
                  width={4.25}
                  onChange={(event) => handleChange({ index, event })}
                >
                  {QCNotesCreatorsCategories.map((category) => (
                    <option key={category} value={category}>
                      {category}
                    </option>
                  ))}
                </StyledSelectField>
              </StyledRowColumn>
              <StyledRowColumn>
                <StyledTextAreaField
                  name="remarks"
                  value={data.remarks || ''}
                  onChange={(event) => handleChange({ index, event })}
                />
              </StyledRowColumn>
              <StyledRowColumn>
                <CrossIcon
                  onClick={() => onRemoveRow(index)}
                  color="#1a1918"
                  width="12"
                  height="12"
                  cursor="pointer"
                />
              </StyledRowColumn>
            </tr>
          ))}
        </tbody>
      </StyledQCTable>
    </Box>
  )
}
export default NewQCNoteTable
